import { InventoryItem, InventoryItemType } from "./useInventoryItems";
import useSWRFetcher from "../commonly-stored/fetcher";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { useCallback } from "react";

export interface InventoryItemsResponse {
  inventory_items: InventoryItem[];
}

export default function useGetInventoryItems(itemType?: InventoryItemType) {
  const fetcher = useSWRFetcher<InventoryItemsResponse>();

  const { data, mutate } = useSWR<InventoryItemsResponse>(
    `${settings.api_url}/inventory/items?item_type=${itemType || ""}`,
    fetcher,
  );

  const refreshInventoryItems = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    inventoryItemsResponse: data || null,
    refreshInventoryItems,
  };
}
